import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
export default forwardRef((props, ref) => jsx("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: "#193446",
    ref,
    ...props,
    dangerouslySetInnerHTML: { __html: '<path fill-rule="evenodd" clip-rule="evenodd" d="M2 2.75a.75.75 0 0 0 0 1.5h1.376l2.387 12.887a.75.75 0 0 0 .581.597 2.5 2.5 0 1 0 4.322.016h3.668a2.5 2.5 0 1 0 4.331 0H19a.75.75 0 0 0 0-1.5H7.124l-.278-1.5H19.5a.75.75 0 0 0 .73-.578l2-8.5a.75.75 0 0 0-.73-.922H4.994l-.257-1.387A.75.75 0 0 0 4 2.75zm3.272 3.5 1.296 7h12.338l1.647-7zM8.5 20a1 1 0 1 0 0-2 1 1 0 0 0 0 2m9-1a1 1 0 1 1-2 0 1 1 0 0 1 2 0" fill="currentColor"/>' }
  })
);